export default __webpack_public_path__ + "static/media/main-slider-doctor.86d2ea16.png";